import { useAppStore } from "@/stores/appStore";

export const useFeatureFlags = () => {
  const { checkFeatureFlag } = useAppStore();

  const isFeatureEnabled = (featureFlag) => {
    return checkFeatureFlag(featureFlag);
  };

  return { isFeatureEnabled };
};
